import PropTypes from 'prop-types';
export var storeShape = PropTypes.shape({
    subscribe: PropTypes.func.isRequired,
    setState: PropTypes.func.isRequired,
    getState: PropTypes.func.isRequired,
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/mini-store/esm/PropTypes.js
// module id = 612
// module chunks = 0